import { t } from '@transifex/native';

import { show } from 'pkg/actions/flashes';

import * as endpoints from 'pkg/api/endpoints/auto';
import * as sdk from 'pkg/core/sdk';

import { Event, trackEvent } from 'components/analytics';

interface ShareSessionPayload {
	targetOrganizationIds: number[];
}

export const shareSession = async (
	organizationId: number,
	trainingCollectionId: number,
	payload: ShareSessionPayload
) => {
	const request = await sdk.put(
		endpoints.TrainingCollections.UpdateOrganizationShare(
			organizationId,
			trainingCollectionId
		),
		{},
		payload
	);

	if (!request.ok) {
		show({
			title: t('Something went wrong!'),
			message: request.statusText,
		});

		return false;
	}

	// Track collection sharing
	trackEvent(Event.TrainingCollectionShare, {
		collection_id: trainingCollectionId,
		target_organization_count: payload.targetOrganizationIds.length,
		target_organization_ids: payload.targetOrganizationIds,
	});

	show({
		title: t('Success!'),
		message: t(
			'Your training collections shared organizations has been updated'
		),
	});

	return true;
};
